import React, { useEffect, useState } from "react";
import { Link, ResponsiveImage } from "@quintype/components";

import { getCollection } from "../../helper/api";

import "./horoscope-grid.m.css";
import { useSelector } from "react-redux";
import { get } from "lodash";

const ZodiacIcon = ({ slug }) => (
  <div styleName="zodiac-icon-wrapper">
    <ResponsiveImage slug={slug} widths={[100]} />
  </div>
);
const HoroscopeGrid = () => {
  const horoscope_icons = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "horoscope_icons"])
  );
  const delay = 2000;
  const [isVisible, setIsVisible] = useState(false);
  const [url, setUrl] = useState("/");
  const Horoscopes = [
    {
      icon: <ZodiacIcon slug={horoscope_icons.aries} />,
      name: "Aries",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.taurus} />,
      name: "Taurus",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.gemini} />,
      name: "Gemini",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.cancer} />,
      name: "Cancer",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.leo} />,
      name: "Leo",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.virgo} />,
      name: "Virgo",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.libra} />,
      name: "Libra",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.scorpio} />,
      name: "Scorpio",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.sagittarius} />,
      name: "Sagittarius",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.capricon} />,
      name: "Capricorn",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.aquarius} />,
      name: "Aquarius",
      link: url
    },
    {
      icon: <ZodiacIcon slug={horoscope_icons.pisces} />,
      name: "Pisces",
      link: url
    }
  ];

  useEffect(() => {
    setTimeout(
      async () => await getCollection("daily-horoscope", 0, 1).then((response) => setUrl(response[0].url)),
      delay
    );
    setTimeout(() => setIsVisible(true), delay + 500);
  }, []);

  return isVisible ? (
    <div styleName="wrapper">
      {Horoscopes.map((item, index) => (
        <Link key={index} href={item.link} styleName="item-wrapper">
          <div styleName="item-icon">{item.icon}</div>
          <span styleName="item-name">{item.name}</span>
        </Link>
      ))}
    </div>
  ) : null;
};

export default HoroscopeGrid;
